module.exports = __webpack_public_path__ + "static/media/18_blanco.764e8eb7.svg";